//@ts-ignore
import Modal from '@mindtickle/modal';
import { InjectedIntl } from 'react-intl';
import messages from './messages';

export const showLogoutAlert = ({ intl }: { intl?: InjectedIntl }) => {
  Modal.confirm({
    title: intl!.formatMessage(messages.callAITitle),
    closable: false,
    width: 400,
    footerBtnProps: {
      okButtonProps: {
        type: 'primary',
        size: 'medium',
      },
    },
    okButtonText: intl!.formatMessage(messages.reloadBtn),
    onOk: () => window.location.reload(),
  });
};

export const getCallAIRedirectionUrl = (locale: string) => {
  let callAIRedirectUrl = `/api/integrations/mindtickle?auth_redirect_uri=${process.env.CALL_AI_AUTHENTICATION_BASE_URL}&embed=true`;
  if (locale) {
    callAIRedirectUrl = `${callAIRedirectUrl}&locale=${locale}`;
  }
  return callAIRedirectUrl;
};
